<template>
  <div class="container-xl mt-4">
    <div class="row row-cards">
      <div class="col-md-3"></div>
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">手機號碼驗證</h3>
          </div>
          <div class="card-body">
            <div
              :class="
                alertStatus === 'Success'
                  ? 'alert alert-success'
                  : 'alert alert-danger'
              "
              v-show="alertStatus !== ''"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-md-2">手機號碼</div>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control"
                  name="example-disabled-input"
                  disabled
                  v-model="phoneDataForm.phoneCountryCode"
                />
              </div>
              <div class="col-md-5">
                <input
                  type="text"
                  class="form-control"
                  name="example-disabled-input"
                  v-model="phoneDataForm.phoneNumber"
                  placeholder="912345678"
                  :disabled="isPhoneNumberSet ? true : false"
                />
              </div>
              <div class="col-md-3">
                <button
                  id="sendVerifySMS"
                  @click.prevent="sendVerifySMS"
                  class="btn btn-outline-primary w-100"
                >
                  {{ smsVerificationButtonText }}
                </button>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-md-2">驗證碼</div>
              <div class="col-md-10">
                <input
                  type="number"
                  class="form-control"
                  name="example-disabled-input"
                  value=""
                  v-model="verificationCode"
                />
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <router-link
                      to="myProfile"
                      class="btn btn-outline-secondary w-100"
                    >
                      返回
                    </router-link>
                  </div>
                  <div class="col-md-6">
                    <a
                      href="#"
                      @click.prevent="verifySMSCode"
                      class="btn btn-outline-primary w-100"
                    >
                      驗證
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      alertMsg: "",
      alertStatus: "",
      token: "",
      phoneDataForm: {
        phoneCountryCode: "",
        phoneNumber: "",
      },
      isPhoneNumberSet: false,
      verificationCode: "",
      countDown: 60,
      smsVerificationButtonText: '發送驗證碼'
    };
  },
  methods: {
    async sendVerifySMS() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/sms/send`;
      const vm = this;
      if (!/^9\d{8}$/.test(vm.phoneDataForm.phoneNumber)) {
        this.alertStatus = "Error";
        this.alertMsg = "手機格式錯誤";
      } else {
        try {
          const res = await this.$http.post(api, vm.phoneDataForm, {
            headers: { Authorization: `Bearer ${this.token}` },
          });
          if (res.data.status !== "success") {
            throw "error";
          }
          const countDown = setInterval(() => {
            document.getElementById("sendVerifySMS").setAttribute("disabled","disabled");
            document.getElementById("sendVerifySMS").innerHTML = --this.countDown + 's';
            
            if (this.countDown == 0) {
              document.getElementById("sendVerifySMS").innerHTML = this.smsVerificationButtonText;
              document.getElementById("sendVerifySMS").removeAttribute("disabled");
              clearInterval(countDown)
            }
          }, 1000)
          this.alertStatus = "Success";
          this.alertMsg = "已發送";
        } catch (err) {
          if (err.response.status === 401) {
            this.$parent.$parent.isExpired = true;
            this.$parent.$parent.checkSessionExpired()
          }
          this.alertStatus = "Error";
          this.alertMsg = "錯誤";
        }
      }
    },
    async verifySMSCode() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/sms/verify`;
      try {
        const res = await this.$http.patch(
          api,
          { verificationCode: this.verificationCode },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );
        this.$router.push("myProfile");
      } catch (err) {
        this.alertStatus = "Error";
        this.alertMsg = "驗證碼錯誤";
      }
    },
    async getProfileInfo() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me`;
      const res = await this.$http.get(api, {
        headers: { Authorization: `Bearer ${this.token}` },
      });

      // check permission
      if (res.data.data.phoneVerification) {
        this.$router.push("myProfile");
      }

      this.phoneDataForm.phoneNumber = res.data.data.phoneNumber;
      if (
        res.data.data.phoneCountryCode &&
        res.data.data.phoneCountryCode.trim()
      ) {
        this.phoneDataForm.phoneCountryCode = res.data.data.phoneCountryCode;
      } else {
        this.phoneDataForm.phoneCountryCode = "886";
      }

      if (res.data.data.phoneNumber && res.data.data.phoneNumber.trim()) {
        this.isPhoneNumberSet = true;
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getProfileInfo();
  },
};
</script>